import "./assets/css/tailwind.css";
import Vue from "vue";
import App from "./App.vue";

import store from "./store/store";
import router from "./router/router";

import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";

// start import leaflet stuff
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
// import "leaflet-draw/dist/leaflet-draw.css";
// Vue.component("l-map", LMap);
// Vue.component("l-tile-layer", LTileLayer);
// Vue.component("l-marker", LMarker);

// end import leaflet stuff

import VueFormulate from "@braid/vue-formulate";

Vue.use(VueFormulate);

Sentry.init({
  dsn:
    "https://5cd3c17240714e858b1c82f6812e73ed@o472904.ingest.sentry.io/5507180",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true
    }),
    new Integrations.BrowserTracing()
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
});

Vue.config.productionTip = false;

const authorizationMixin = {
  methods: {
    hasPermission(permission) {
      return this.$store.state.user.permissions.includes(permission);
    }
  }
};

Vue.mixin(authorizationMixin);

new Vue({
  render: h => h(App),
  store,
  router
}).$mount("#app");
